import { observer } from "mobx-react";
import ReturnMethodStore from "../../../stores/return-method-store";
import { FormFieldLine } from "../../../../../components/form-field-line/form-field-line";
import { SelectDropdown } from "../../../../../components/inputs/select-dropdown/select-dropdown";
import { IValidationGroup } from "../../../../../hooks/validation-group/validation-group-hook";
import { ShippingInstructionsChangeTrigger } from "../../../return-method-types";
import { InstrucionsWarningFieldLine } from "../instructions-warning";
import { NOTE_TYPE, Note } from "../../../../../components/note/note";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface Props {
    returnMethod?: ReturnMethodStore;
    validationGroup: IValidationGroup;
}

const DropOffConnectionField: React.FC<Props> = observer(({returnMethod, validationGroup}: Props) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-return-method-editor';
    if (!returnMethod ){
        return null;
    }

    const aggregatorsList = returnMethod.getDropOffIntegrationAggregators();
    const selectedAggregator = aggregatorsList.find(aggregator => aggregator.value === returnMethod.dropOffSettings?.shippingConnectionId) ;
    const warningText = returnMethod.getWarningText();
    

    const onConnectionChange = (v: number) => {
        returnMethod.dropOffSettings?.setShippingConnectionId(v)
    }
    
    return(
        <>
            <FormFieldLine 
                label={getTranslation("CONNECTION", scope)} 
                note={getTranslation("CONNECTION_NOTE", scope)}
            >
                <SelectDropdown
                    value={selectedAggregator}
                    options={aggregatorsList}
                    onChange={(value) => {onConnectionChange(value?.value as number)}}
                    required
                    validationGroup={validationGroup}
                />
            </FormFieldLine>
            { warningText &&
                <FormFieldLine label="">
                    <Note type={NOTE_TYPE.WARNING} body={warningText} />
                </FormFieldLine>
            }
            <InstrucionsWarningFieldLine returnMethod={returnMethod} trigger={ShippingInstructionsChangeTrigger.DROP_OFF_CONNECTION} />
        </>
    )
})

export default DropOffConnectionField;